module.exports = __webpack_public_path__ + "img/chevron-left.b76af6e0.svg";